/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 * Types for Modal component
 *
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.0.0
 */
import { ReactElement } from 'react';

export interface IModalList {
    [id: string]: {
        isOpen: boolean;
        modalParams?: IModalParams;
        onCloseCallback?: () => void;
        render: (props: IModalRenderProps) => ReactElement;
        status: EModalStatus;
    };
}

export interface IModalParams {
    autoFocus?: boolean;
    closeable?: boolean;
    isCustomCrossButton?: boolean;
    isDisableBackgroundClickClose?: boolean;
}

export interface IModalRenderProps {
    id: string;
    onCloseModal: () => void;
}

export enum EModalStatus {
    failure = 'failure',
    processing = 'processing',
    start = 'start',
    success = 'success',
}
